import apiClient from './apiClient';

export const getIstoricClient = (clientId) =>
  apiClient.get(`/clienti/${clientId}/istoric/`).then(r => r.data);
